type LogLevel = 'error' | 'warn' | 'info';

interface LogEntry {
  level: LogLevel;
  message: string;
  context?: string;
  error?: unknown;
  data?: Record<string, unknown>;
}

function formatEntry(entry: LogEntry): string {
  const parts = [`[${entry.level.toUpperCase()}]`];
  if (entry.context) parts.push(`[${entry.context}]`);
  parts.push(entry.message);
  return parts.join(' ');
}

function extractErrorDetails(error: unknown): Record<string, unknown> {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  return { raw: String(error) };
}

export const logger = {
  error(message: string, options: { context?: string; error?: unknown; data?: Record<string, unknown> } = {}) {
    const { context, error, data } = options;
    const structured: LogEntry = { level: 'error', message, context, error, data };
    const errorDetails = error !== undefined ? extractErrorDetails(error) : undefined;
    console.error(formatEntry(structured), ...(errorDetails ? [errorDetails] : []), ...(data ? [data] : []));
  },

  warn(message: string, options: { context?: string; data?: Record<string, unknown> } = {}) {
    const { context, data } = options;
    const structured: LogEntry = { level: 'warn', message, context, data };
    console.warn(formatEntry(structured), ...(data ? [data] : []));
  },

  info(message: string, options: { context?: string; data?: Record<string, unknown> } = {}) {
    const { context, data } = options;
    const structured: LogEntry = { level: 'info', message, context, data };
    console.info(formatEntry(structured), ...(data ? [data] : []));
  },
};
